import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  divider: {
    margin: 0
  },
  readAll: {
    color: token.colorPrimary,
    cursor: 'pointer'
  }
}))
